module.exports = __webpack_public_path__ + "static/img/21.21ed3c01.gif";